import { OPTIONS_DELETE, OPTIONS_CLEAR_ALL, OPTIONS_DATA, OPTIONS_ERROR, OPTIONS_LOADING } from "../actions/actionTypes";

const initialState = {
	imgSuccess: false,
    pollOptions:{}
};

export default function pollOptionsReducer(state = initialState, action) {
	const { type, payload } = action;
	let objPollOptions;
	switch (type) {
		case OPTIONS_LOADING:
			let key =  `${payload?.name}`;
			objPollOptions = state?.pollOptions
			objPollOptions[key] = {
				loading:true,
				data:{},
				error:""
			}
			return {
				...state,
				imgSuccess:false,
				pollOptions:objPollOptions
			}
		case OPTIONS_DATA:
			objPollOptions = state?.pollOptions;
			objPollOptions[payload?.name] = {
				loading:false,
				data:payload?.link,
				error:""
			}
			return {
				...state,
				imgSuccess:true,
				pollOptions:objPollOptions
			};
		case OPTIONS_DELETE:
			objPollOptions = state?.pollOptions;
			delete objPollOptions[payload?.name];
			return {
				...state,
				imgSuccess:true,
				pollOptions:objPollOptions
			};
		case OPTIONS_ERROR:
			objPollOptions = state?.pollOptions;
			objPollOptions[payload?.name] = {
				loading:false,
				data:{},
				error:payload?.msg
			}
			return {
				...state,
				imgSuccess:false,
				pollOptions:objPollOptions
			};
		case OPTIONS_CLEAR_ALL:
			return {
				imgSuccess:false,
				pollOptions:{}
			};
		default:
			return state;
	}
}
